<div
  class="header h-[55px] flex justify-start items-center pl-[40px] bg-[#F1F3F5] overflow-y-hidden"
>
  <p class="!m-0 text-[18px]">
  {{ projectName }} - Pre-Qualification Questionnaire (PQQ)
  </p>
  <p
    class="text-[#343A40] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] !w-[136px] !h-[19px] flex items-center justify-center"
  >
    Select Companies
  </p>
</div>
<div class="!w-full overflow-y-hidden">
  <div
    class="!pl-[20px] !ml-[20px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="mt-[0px] m-[0px] pt-[12px] wrapper">
      <mat-form-field
        appearance="outline"
        class="custom-mat-form-field !rounded-2xl !w-[429px] !mb-[11px]"
      >
      <mat-label>Company</mat-label>
        <mat-select
          [formControl]="organizationControl"
          [value]="selectedOrganizations"
          style="font-size: 14px !important"
          (selectionChange)="addOrganization()"
        >
          <!-- Custom Search Input Inside the Mat-Select Dropdown -->
          <div class="search-container" mat-select-header>
            <div class="relative flex">
              <input
                type="text"
                placeholder="Search "
                [(ngModel)]="searchTerm"
                (input)="filterOrganizations()"
                class="search-input"
              />
              <img
                class="absolute right-[15px] mt-[20px] transform -translate-y-[50%] w-[1.1rem] h-[1.1rem] rounded-full"
                src="assets/icons/search.svg"
                alt="message icon"
              />
            </div>
          </div>
          <!-- Organization Options -->
          <mat-option
            (click)="otherSelection()"
            class="hover:!bg-[#fae8e1]"
            >External Company</mat-option
          >
          <ng-container *ngFor="let org of filteredOrganizations">
            <mat-option [value]="org" (click)="DetailOrganizations(org)" class="!border-t">
              {{ org?.name }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="other" class="!pt-[12px]">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label>Company Name</mat-label>
          <input
            matInput
            [formControl]="company_name"
            placeholder="Company Name"
            (keydown.enter)="DetailOrganizations('')"
          />
        </mat-form-field>
        <mat-error *ngIf="other && company_name.hasError('required') && (company_name.touched || company_name.dirty)">Company Name is required.</mat-error>
      </div>
    </div>
  </div>

  <div
    class="!pl-[20px] !ml-[20px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Name </mat-label>
          <input matInput [formControl]="name" placeholder="Name" />
        </mat-form-field>        
        <mat-error *ngIf="name.hasError('required') && (name.touched || name.dirty)">Name is required.</mat-error>
      </div>
    </div>
  </div>
  <div
    class="!pl-[20px] !ml-[20px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Email </mat-label>
          <input matInput [formControl]="email" placeholder="Email" />
        </mat-form-field>
        <mat-error *ngIf="email.hasError('required') && (email.touched || email.dirty)">Email is required.</mat-error>
      </div>
    </div>
  </div>
  <div
    class="!pl-[20px] !ml-[20px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0">
        <mat-form-field class="!w-[429px] !mb-[11px]" appearance="outline">
          <mat-label> Position </mat-label>
          <input matInput [formControl]="position" placeholder="Position" />
        </mat-form-field>
        <mat-error *ngIf="position.hasError('required') && (position.touched || position.dirty)">Position is required.</mat-error>
      </div>
    </div>
  </div>
</div>
<div
  class="!pl-[20px] !ml-[20px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
>
  <div class="!w-[429px] flex justify-end items-center">
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="addOrganizationDetail()"
    >
      Add
    </button>
  </div>
</div>

<div class="!mr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 table-scrolling">
  <div class="!w-[100%] flex items-center">
    <table
      class="!w-[100%] bg-[#fcfcfd] table-auto !ml-[40px]"
      style="margin-right: 0px"
    >
      <thead
        class="h-[52px] !bg-[#DEE2E6] text-[#343A40] !text-center justify-center !p-[20px] sticky top-0 z-20"
      >
        <tr>
          <th class="px-4 py-2 text-left w-auto">Company</th>
          <th class="px-4 py-2 text-left w-auto">Name</th>
          <th class="px-4 py-2 text-left w-auto">Email</th>
          <th class="px-4 py-2 text-left w-auto">Position</th>
          <th class="px-4 py-2 text-center w-auto">Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr
            *ngFor="let orgDetail of organizationDetails; let i = index"
            class="!h-[52px] border-b-0 items-center justify-center"
            [ngClass]="{
              'bg-white': i % 2 === 0,
              'bg-[#DEE2E6]': i % 2 !== 0
            }"
          >
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.company_name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.email }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.position }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-center cursor-pointer">
              <mat-icon>more_vert</mat-icon>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="!pr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button (click)="handleBack()" type="button" class="back-btn">Back</button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="moveToNextStep()"
    >
      Next
    </button>
  </div>
</div>
